import { Badge } from "../ui/badge";
import { calculateMeetupPricing, formatMoney } from "../../lib/meetupPricing";
import { ShieldCheck } from "lucide-react";

export default function MeetupPinHoverCard({ pin, businessView = false }) {
  if (!pin) return null;

  const pricing = calculateMeetupPricing({
    basePrice: pin.base_price_usd || 75,
    guests: 2,
    country: pin.country || "barbados",
  });

  return (
    <div className="absolute top-4 right-4 z-[4000] w-72 rounded-2xl border border-cyan-100 bg-slate-950/95 text-white shadow-2xl p-4 pointer-events-none">
      <p className="text-[10px] uppercase tracking-wide text-cyan-300 font-semibold mb-1">
        {pin.parish ? `${pin.parish} · ` : ""}
        {pin.island}
      </p>
      <p className="font-semibold leading-snug">{pin.name}</p>
      {pin.description && (
        <p className="text-xs text-slate-300 mt-2 line-clamp-2">{pin.description}</p>
      )}
      <div className="flex flex-wrap gap-1.5 mt-3">
        {pin.is_featured && (
          <Badge className="bg-emerald-500/20 text-emerald-200 border-0 text-[10px]">
            <ShieldCheck className="w-3 h-3 mr-1" /> Verified
          </Badge>
        )}
        <Badge className="bg-white/10 text-white border-0 text-[10px] capitalize">{pin.kind}</Badge>
      </div>
      <div className="mt-3 pt-3 border-t border-white/10 text-xs space-y-1">
        {!businessView ? (
          <>
            <div className="flex justify-between">
              <span className="text-slate-400">All-in price</span>
              <span className="font-semibold">{formatMoney(pricing.totalPrice)}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-400">VAT/GCT incl.</span>
              <span>{formatMoney(pricing.vatCollected)}</span>
            </div>
          </>
        ) : (
          <div className="flex justify-between">
            <span className="text-slate-400">Partner payout</span>
            <span className="font-semibold">{formatMoney(pricing.businessPayout)}</span>
          </div>
        )}
      </div>
      <p className="text-[10px] text-slate-500 mt-2">Click pin for Map Friend · directions</p>
    </div>
  );
}
